import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import Card from '../components/Card'

const helpTopics = {
  'getting-started': {
    title: 'Getting Started',
    sections: [
      {
        id: 'intro',
        title: 'Introduction',
        content: 'Welcome to Snagmatic! This app lets you report infrastructure issues in your community.',
      },
      {
        id: 'how-to-report',
        title: 'How to Report',
        content: 'Tap "Report an Issue", take a photo, select the type of issue, enter location, and submit.',
      },
    ],
  },
  'reporting': {
    title: 'Reporting Issues',
    sections: [
      {
        id: 'what-to-report',
        title: 'What Can I Report?',
        content: 'Currently: potholes, damaged signage, broken guardrails. More categories coming soon.',
      },
      {
        id: 'photo-tips',
        title: 'Photo Tips',
        content: 'Take clear, well-lit photos showing the damage. Include context so authorities can locate it.',
      },
    ],
  },
  'tracking': {
    title: 'Tracking Your Report',
    sections: [
      {
        id: 'status',
        title: 'Report Status',
        content: 'Pending: Just submitted. Acknowledged: The responsible organization received it. Resolved: Issue fixed.',
      },
    ],
  },
}

export default function HelpShell() {
  const { '*': topic = 'getting-started' } = useParams()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const currentTopic = helpTopics[topic]

  return (
    <div className="min-h-screen bg-surface-dark flex pb-20">
      {/* Sidebar */}
      <aside
        className={`${
          sidebarOpen ? 'fixed inset-0 z-40' : 'hidden'
        } md:block md:relative md:z-0 w-64 bg-surface border-r border-border p-4 md:p-6 md:overflow-y-auto`}
      >
        <div className="flex items-center justify-between mb-6 md:block">
          <h2 className="text-headline-md">Help</h2>
          <button
            onClick={() => setSidebarOpen(false)}
            className="md:hidden text-text-primary"
          >
            ✕
          </button>
        </div>

        <nav className="space-y-2">
          {Object.entries(helpTopics).map(([id, t]) => (
            <Link
              key={id}
              to={`/help/${id}`}
              onClick={() => setSidebarOpen(false)}
              className={`block px-4 py-2 rounded-lg transition-colors ${
                topic === id
                  ? 'bg-accent text-white'
                  : 'hover:bg-surface-bright text-body-md'
              }`}
            >
              {t.title}
            </Link>
          ))}
        </nav>
      </aside>

      {/* Sidebar Toggle (Mobile) */}
      {!sidebarOpen && (
        <button
          onClick={() => setSidebarOpen(true)}
          className="md:hidden fixed bottom-8 right-8 bg-accent text-white p-3 rounded-full z-30"
        >
          ☰
        </button>
      )}

      {/* Main Content */}
      <main className="flex-1 p-4 sm:p-6">
        {currentTopic ? (
          <div className="max-w-2xl">
            <h1 className="text-headline-lg mb-8">{currentTopic.title}</h1>

            <div className="space-y-6">
              {currentTopic.sections.map((section) => (
                <Card key={section.id}>
                  <h2 className="text-headline-md mb-3">{section.title}</h2>
                  <p className="text-body-md text-text-secondary">{section.content}</p>
                </Card>
              ))}
            </div>
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-body-lg text-text-secondary">Topic not found</p>
          </div>
        )}
      </main>
    </div>
  )
}
